import React, { Component } from 'react'
import Web3 from 'web3'
import ipfs from './../../ipfs'
import utils from './../../library'
import './css.css';



class ShopMeta extends Component {
constructor(props){
    super()
  

}

componentDidMount(){
    this.loadMeta()
}

async uploadipfs() {

  
  }

async loadMeta(){
  
        let addr=""
        await window.ethereum.enable().then(async function (accounts) {
            let metafound=false
            let mtdt
            const { REACT_APP_METAABI } = await process.env;
            const { REACT_APP_META } = await  process.env;
            if(getUrlVars()["shop"]){
            addr=getUrlVars()["shop"]
            const metadata = new web3.eth.Contract(JSON.parse(REACT_APP_METAABI), REACT_APP_META) 
            mtdt=await metadata.methods.meta(addr).call()
            if(mtdt.length>=0)metafound=true
            console.log("MTDT>>>>Z> "+addr+" "+REACT_APP_META,mtdt)
            }
            if((!getUrlVars()["shop"])||(!metafound)){
            addr=accounts[0]
            const metadata = new web3.eth.Contract(JSON.parse(REACT_APP_METAABI), REACT_APP_META) 
            mtdt=await metadata.methods.meta(addr).call()
            }
            document.getElementById("Shop_twitter_pan").style.display='none'
            document.getElementById("Shop_discord_pan").style.display='none'
                   
            if(mtdt.length>0){
                console.log("MTDT",mtdt)
                fetch(formatURL(mtdt)).then(response => response.json()).then(
                response => {
                    console.log(JSON.stringify(response))
                    try{
                    document.getElementById("Shop_meta_setname").value=response[0]["name"]
                    document.getElementById("Shop_meta_setdesc").value=response[0]["description"]
                    document.getElementById("Shop_meta_setimage").value=response[0]["image"]
                    document.getElementById("Shop_meta_setdiscord").value=response[0]["discord"].replace(/[^\w\s]/gi, '')
                    document.getElementById("Shop_meta_settwitter").value=response[0]["twitter"].replace(/[^\w\s]/gi, '')
                    document.getElementById("Shop_meta_setdark").value=response[0]["dark"].substring(1,7)
                    document.getElementById("Shop_meta_setlight").value=response[0]["light"].substring(1,7)
                    document.getElementById("Shop_meta_settext").value=response[0]["text"].substring(1,7)
                    utils.setBackground(response[0])
                }catch(e){alert(e)}
                    document.getElementById("Shop_header_mainlabel").textContent=response[0]["name"]
                    document.getElementById("Shop_header_description").textContent=response[0]["description"]
                    let back=response[0]["image"]
                    if(back=="")back='https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/27592dd5-bdf2-4e90-9e17-852077de3dd0/d2aytcz-fd1a408a-541d-465d-9f8d-9c662b5ba6db.jpg/v1/fill/w_900,h_600,q_75,strp/fading_blue_grunge_by_dyingbeautystock.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwic3ViIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl0sIm9iaiI6W1t7InBhdGgiOiIvZi8yNzU5MmRkNS1iZGYyLTRlOTAtOWUxNy04NTIwNzdkZTNkZDAvZDJheXRjei1mZDFhNDA4YS01NDFkLTQ2NWQtOWY4ZC05YzY2MmI1YmE2ZGIuanBnIiwid2lkdGgiOiI8PTkwMCIsImhlaWdodCI6Ijw9NjAwIn1dXX0.JSbyhtv1aQd2O8AzG2x1UTZLfyNdtwGNtNSgzKCDFTE'
                    
                    document.getElementById("Shop_header_image").style.backgroundImage='url('+back+')'
        
                    if(response[0]["twitter"].length>0){
                        document.getElementById("Shop_twitter_pan").addEventListener("click", () => jumpsocial("https://twitter.com/"+response[0]["twitter"].replace(/[^\w\s]/gi, '')))
                        document.getElementById("Shop_twitter_pan").style.display='visible'
                        
                    }

                    if(response[0]["discord"].length>0){
                        document.getElementById("Shop_discord_pan").addEventListener("click",  () => jumpsocial("https://discord.gg/"+response[0]["discord"].replace(/[^\w\s]/gi, '')))
                        document.getElementById("Shop_discord_pan").style.display='visible'
                    }
   
                })
            }

        })
    
}



async save(){
    let addr=""
    
    let hash=await this.uploadipfs()
    await window.ethereum.enable().then(async function (accounts) { 
        
            addr=accounts[0]
        
        if(getUrlVars()["shop"]>0)addr=getUrlVars()["shop"]
        
        let name=document.getElementById("Shop_meta_setname").value
        let desc=document.getElementById("Shop_meta_setdesc").value
        let imag=document.getElementById("Shop_meta_setimage").value
        let dark=document.getElementById("Shop_meta_setdark").value
        let light=document.getElementById("Shop_meta_setlight").value
        let textcolor=document.getElementById("Shop_meta_settext").value
        let disc=document.getElementById("Shop_meta_setdiscord").value
        let twit=document.getElementById("Shop_meta_settwitter").value
        let str='[{"name":"'+name+'","description":"'+desc+'","image":"'+imag+'","dark":"#'+dark+'","light":"#'+light+'","text":"#'+textcolor+'","discord":"'+disc+'","twitter":"'+twit+'"}]'
        var enc = new TextEncoder(); // always utf-8
        const buffer = await Buffer.from(str);
        console.log("IPFS1");
        await ipfs.add(buffer).then(async (response) => {
          console.log(response["path"]);
          const { REACT_APP_METAABI } = process.env;
          const { REACT_APP_META } = process.env;
          const meta = new web3.eth.Contract(JSON.parse(REACT_APP_METAABI), REACT_APP_META) 
          if(!getUrlVars()["shop"]){
          await meta.methods.setWalletMeta(response["path"].toString()).send({from: accounts[0] , gas: 123456 })
          }else{
            await meta.methods.setModuleMeta(addr,response["path"].toString()).send({from: accounts[0] , gas: 123456 })   
          }
        }).catch((err) => {
        
          console.error(err)
       
        })
       
      
})  
this.loadMeta()
}

check(x) {
    let elements = document.getElementsByClassName(x);
    for (var i = 0; i < elements.length; i++) {
        elements[i].style.backgroundColor="red";
    }
}

    render(){
let target="avatar"
if(getUrlVars()["shop"])target="shop"
        return ( 
            <>
        <div className="Shop_meta_row">        
            <div className="Shop_meta_panel dark darkblue text white">
  
               <span className=" right">{target} metadata ✨</span>
               <div className="clear"></div>
               <br></br>
               <div>
               <span>🛒shop name:</span><br></br>
               <input id="Shop_meta_setname" className="Shop_meta_setval light lightblue text white" type="text" ></input>
               </div>
               <div>
               <span>🏷️ description:</span><br></br>
               <input id="Shop_meta_setdesc" className="Shop_meta_setval light lightblue text white" type="text" ></input>
               </div>
               <div>
               <span>🖼️ image url (800*200):</span><br></br>
               <input id="Shop_meta_setimage" className="Shop_meta_setval light lightblue text white" type="text" ></input>
               </div>
               <div>
               <span>🎨 colors (dark and light and text):</span><br></br>
               <div className="metacontent_left">#</div>
               <input id="Shop_meta_setdark" className="Shop_meta_setval_color light lightblue text white" type="text" ></input>
               <div className="metacontent_right">#</div>
               <input id="Shop_meta_setlight" className="Shop_meta_setval_color light lightblue text white" type="text" ></input>
               <div className="metacontent_right">#</div>
               <input id="Shop_meta_settext" className="Shop_meta_setval_color light lightblue text white" type="text" ></input>
               
               <div className="clear"></div>
               </div>
               <div>
               <span>👾 discord server:</span><br></br>
               <div className="metacontent">https://discord.gg/</div><input id="Shop_meta_setdiscord" className="Shop_meta_setval_discord light lightblue text white" type="text" ></input>
               <div className="clear"></div>
               </div>
               <div>
               <span>🐤 twitter:</span><br></br>
               <div className="metacontent">https://twitter.com/</div><input id="Shop_meta_settwitter" className="Shop_meta_setval_twitter light lightblue text white" type="text" ></input>
               <div className="clear"></div>
               </div>
               <input className="Shop_meta_setmeta_button light lightblue text white" type="button" value="🏹 save" onClick={() => this.save()}></input>
               <br></br><br></br>     
            </div>
        </div>
       </>
            
        );
    }


}

function jumpsocial(add){
    window.open(add)
}



function formatURL(url){
    return("https://gateway.ipfs.io/ipfs/"+url);
  }

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}


        
const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")




export default ShopMeta